/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const ko_course_attachments_uploadtitle1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`파일 업로드`)
};

const en_course_attachments_uploadtitle1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`File Upload`)
};

const ja_course_attachments_uploadtitle1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ファイルアップロード`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "ko" | "en" | "ja" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
const course_attachments_uploadtitle1 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.course_attachments_uploadtitle1(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("course_attachments_uploadtitle1", locale)
	if (locale === "ko") return ko_course_attachments_uploadtitle1(inputs)
	if (locale === "en") return en_course_attachments_uploadtitle1(inputs)
	return ja_course_attachments_uploadtitle1(inputs)
};
export { course_attachments_uploadtitle1 as "course_attachments_uploadTitle" }